import {selectors} from '../../constants';
import {Components, SignInControl, SignInForm} from './components';
import {MasterControl} from './master-control';

export {SignUpControl} from './sign-up-control';
export {MasterControl, SignInControl, SignInForm};

export interface UiService {
  masterControl: MasterControl;
  forms: Components<SignInForm>;
  controls: Components<SignInControl>;
}

export const ui: UiService = {
  masterControl: new MasterControl(selectors.MASTER_CONTROL),
  forms: new Components(selectors.FORM, el => new SignInForm(el)),
  controls: new Components(selectors.CONTROL, el => new SignInControl(el)),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/shared/ui/index.ts